exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".yc-logs[data-v-890faa4a]{padding:20px}.page-head[data-v-890faa4a]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:16px}.page-head h2[data-v-890faa4a]{margin:0}.page-actions[data-v-890faa4a]{display:-ms-flexbox;display:flex;gap:8px}.pager[data-v-890faa4a]{margin-top:14px;text-align:right}.log-content[data-v-890faa4a]{max-height:60vh;overflow:auto;margin:0;padding:12px;background:#1e1e1e;color:#d4d4d4;border-radius:4px;font-size:12px;line-height:1.6;white-space:pre-wrap;word-break:break-all}.todo-tip[data-v-890faa4a]{margin-top:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-890faa4a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/admin/views/yingchuan/Logs.vue
// module id = 148
// module chunks = 0